// Analytics implementations
declare global {
  interface Window {
    ga: any;
    gtag: any;
   }
}
export interface event {
  category: string,
  action: string,
  label: string | number | undefined | null
}

export const ga = {
  event (event: event) {
    const label = event.label !== null && event.label !== undefined ? event.label.toString() : ''
    window.ga('send', 'event', event.category, event.action, label);
    window.gtag('event', event.category, {
      'action': event.action,
      'label': label
    });
  }
}